/**
 * Brazilian Portuguese (pt-BR) mappings for Football Dashboard
 * Covers all football dashboard components
 */

export const footballDashboardPtBR = {
  // Header
  "Sports Hub • Football": "Centro Esportivo • Futebol",
  "Football Terminal": "Terminal de Futebol",
  "Track live games, tables, and top players from football leagues worldwide.": "Acompanhe jogos ao vivo, tabelas e principais jogadores de ligas de futebol no mundo todo.",

  // Main Dashboard
  "Football Dashboard": "Painel de Futebol",
  "Loading fixtures...": "Carregando jogos...",
  "Select Date": "Selecionar Data",
  "Today (ET)": "Hoje (ET)",
  "Tomorrow": "Amanhã",
  "Popular": "Popular",
  "All Leagues": "Todas as Ligas",
  "Search leagues...": "Buscar ligas...",
  "No leagues found": "Nenhuma liga encontrada",
  "Loading leagues...": "Carregando ligas...",
  "No games found": "Nenhum jogo encontrado",
  "Try selecting a different date or league": "Tente selecionar uma data ou liga diferente",
  "Showing": "Mostrando",
  "games": "jogos",
  "game": "jogo",
  
  // Fixture Card
  "Predict": "Previsão",
  "Odds": "Cotações",
  "Selected": "Selecionado",
  "View Odds": "Ver Cotações",
  "Betting Odds": "Cotações de Apostas",
  "Pre-Match Odds": "Cotações Pré-Jogo",
  "Live Odds": "Cotações ao Vivo",
  "Best Odds": "Melhores Cotações",
  "No odds available": "Sem cotações disponíveis",
  "Odds data not available for this match": "Dados de cotações não disponíveis para esta partida",
  "AI Prediction": "Previsão IA",
  "Live Forecast": "Previsão ao Vivo",
  "Predict Live": "Prever ao Vivo",
  "PREDICT LIVE": "PREVER AO VIVO",
  "Final": "Final",
  "vs": "vs",
  "Winner": "Vencedor",
  "Confidence": "Confiança",
  "Reasoning": "Análise",
  "HIGH": "ALTA",
  "MEDIUM": "MÉDIA",
  "LOW": "BAIXA",
  "MED": "MÉD",
  
  // Prediction Bar (Desktop & Mobile)
  "Game Selected (Max 5)": "Jogo Selecionado (Máx 5)",
  "Games Selected (Max 5)": "Jogos Selecionados (Máx 5)",
  "7 coins per game": "7 moedas por jogo",
  "7 coins/game": "7 moedas/jogo",
  "coins total": "moedas total",
  "Predict Winners": "Prever Vencedores",
  "Predicting...": "Prevendo...",
  "Clear All": "Limpar Tudo",
  "Insufficient Star Coins. Need": "Moedas Estelares Insuficientes. Precisa de",
  "coins.": "moedas.",
  
  // Selection Limit
  "Maximum 5 games per prediction. Submit these first, then select more.": "Máximo de 5 jogos por previsão. Envie estes primeiro, depois selecione mais.",
  
  // Upgrade Notice
  "Upgrade to Pro": "Fazer Upgrade para Pro",
  "Get more predictions": "Obtenha mais previsões",
  "Buy Star Coins": "Comprar Moedas Estelares",
  
  // League Names (Common)
  "Premier League": "Premier League",
  "La Liga": "La Liga",
  "Serie A": "Serie A",
  "Bundesliga": "Bundesliga",
  "Ligue 1": "Ligue 1",
  "UEFA Champions League": "Liga dos Campeões",
  "UEFA Europa League": "Liga Europa",
  "Copa Libertadores": "Copa Libertadores",
  "Copa Sudamericana": "Copa Sul-Americana",
  "Brazil Serie A": "Brasileirão Série A",
  "Brazil Serie B": "Brasileirão Série B",
  "Copa do Brasil": "Copa do Brasil",
  "MLS": "MLS",
  "Liga MX": "Liga MX",
  "World Cup": "Copa do Mundo",
  
  // Status Messages
  "No predictions remaining": "Sem previsões restantes",
  "Loading...": "Carregando...",
  "Error loading data": "Erro ao carregar dados",
  "Try again": "Tentar novamente",
  
  // Time Related
  "ET": "ET",
  "Today": "Hoje",
  "Live": "Ao Vivo",
  "FT": "FT",
  "HT": "INT",
  "NS": "NS",
  
  // Mobile Specific
  "Back": "Voltar",
  "Close": "Fechar",
  "More": "Mais",

  // Chat CTA
  "Analyze in Chat": "Analisar no Chat",
  "More in Chat": "Mais no Chat",
  
  // Prediction Results
  "Prediction saved to chat": "Previsão salva no chat",
  "View in chat": "Ver no chat",
  "Copy prediction": "Copiar previsão",
  "Share": "Compartilhar",
  
  // Error Messages
  "Failed to load fixtures": "Falha ao carregar jogos",
  "Failed to get prediction": "Falha ao obter previsão",
  "Please try again": "Por favor, tente novamente",
  "Network error": "Erro de rede",
  "Something went wrong": "Algo deu errado",
  
  // Quick Actions
  "Select all": "Selecionar todos",
  "Deselect all": "Desmarcar todos",
  "Filter by league": "Filtrar por liga",
  "Sort by time": "Ordenar por horário",
  
  // Stats
  "Form": "Forma",
  "Head to Head": "Confronto Direto",
  "Goals": "Gols",
  "Cards": "Cartões",
  "Corners": "Escanteios",
  
  // Countries
  "England": "Inglaterra",
  "Spain": "Espanha",
  "Italy": "Itália",
  "Germany": "Alemanha",
  "France": "França",
  "Brazil": "Brasil",
  "Argentina": "Argentina",
  "Portugal": "Portugal",
  "Netherlands": "Holanda",
  "Belgium": "Bélgica",
  "USA": "EUA",
  "Mexico": "México",
  
  // Dashboard Header & Description
  "Live matches, standings, player statistics, and betting odds from your tracked leagues": "Jogos ao vivo, classificações, estatísticas de jogadores e odds de apostas das suas ligas acompanhadas",
  "Live Updates": "Atualizações ao Vivo",
  "Betting Odds": "Odds de Apostas",
  "leagues tracked": "ligas acompanhadas",
  "Your Football Hub": "Seu Centro de Futebol",
  
  // Tips & Help
  "Tip:": "Dica:",
  "Select a date to refresh live scores": "Selecione uma data para atualizar placares ao vivo",
  "Use \"Refresh Live Scores\" for real-time updates": "Use \"Atualizar Placares ao Vivo\" para atualizações em tempo real",
  "Coverage expanding across all international leagues": "Cobertura expandindo para todas as ligas internacionais",
  "v3-Beta: Not all features available yet": "v3-Beta: Nem todos os recursos disponíveis ainda",
  "All AI picks saved to chat history": "Todas as apostas da IA salvas no histórico do chat",
  "Go to chat to dive deeper": "Vá para o chat para se aprofundar",
  
  // Refresh & Cache
  "Refresh Live Scores": "Atualizar Placares ao Vivo",
  "Cache:": "Cache:",
  "items": "itens",
  
  // Pagination
  "Page": "Página",
  "of": "de",
  "Previous": "Anterior",
  "Next": "Próximo",
  
  // Players
  "Refresh Players": "Atualizar Jogadores",
  "Players": "Jogadores",
  "Player Statistics": "Estatísticas de Jogadores",
  
  // Match Status
  "Postponed": "Adiado",
  "Cancelled": "Cancelado",
  "Suspended": "Suspenso",
  "Interrupted": "Interrompido",
  "Abandoned": "Abandonado",
  "Not Started": "Não Iniciado",
  "First Half": "Primeiro Tempo",
  "Second Half": "Segundo Tempo",
  "Extra Time": "Prorrogação",
  "Penalty": "Pênaltis",
  "Match Finished": "Jogo Finalizado",
  "Halftime": "Intervalo",
  
  // Additional UI Elements
  "Show More": "Mostrar Mais",
  "Show Less": "Mostrar Menos",
  "All": "Todos",
  "None": "Nenhum",
  "Reset": "Redefinir",
  "Apply": "Aplicar",
  "Cancel": "Cancelar",
  "Confirm": "Confirmar",
  "Save": "Salvar",
  "Delete": "Excluir",
  "Edit": "Editar",
  "Add": "Adicionar",
  "Remove": "Remover",
  "Search": "Buscar",
  "Filter": "Filtrar",
  "Sort": "Ordenar",
  "Export": "Exportar",
  "Import": "Importar",
  "Download": "Baixar",
  "Upload": "Enviar",
  "Refresh": "Atualizar",
  "Reload": "Recarregar",
  "Settings": "Configurações",
  "Options": "Opções",
  "Help": "Ajuda",
  "Info": "Informações",
  "Warning": "Aviso",
  "Success": "Sucesso",
  "Failed": "Falhou",
  "Pending": "Pendente",
  "Processing": "Processando",
  "Complete": "Completo",
  "Incomplete": "Incompleto"
};